import { Dimensions, Platform, StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    overflow: 'hidden',
    paddingHorizontal: 16,
    paddingTop: 32,
    width: '100%'
  },
  filtersContentContainer: {
    padding: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 10,
    paddingBottom: 0,
  },
  divider: {
    height: 1,
    backgroundColor: Colors.veryLightPinkTwo,
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 32 : 12,
    marginHorizontal: 14,
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 32 : 0
  }
})

export default styles
